import request from '@/utils/request'
import gateway from '@/_gateway.config.js'

let { parent } = gateway

// 根据用户ID获取信息
export function getReferrer (params) {
  return request({
    url: `${parent}/api/referral/referrer`,
    method: 'GET',
    params
  })
}

// 记录用户触达后点击行为等事件post
export function recordActivation (data) {
  return request({
    url: `${parent}/api/referral/record/activation`,
    method: 'POST',
    data
  })
}

// 记录学生触达后点击行为等事件post
export function recordStudentActivation (data) {
  return request({
    url: `${parent}/api/referral/record/activation/student`,
    method: 'POST',
    data
  })
}
